export default __webpack_public_path__ + "static/media/team3.38f293b1.jpg";